import TableRow from "components/tableRow";

function GreyhoundRacing() {
    return (
        <>
            <div className='relative w-full'>
                <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>Greyhound Racing</p>
            </div>
            {/* <TableRow /> */}
            <div className="bg-[#fff] text-[#000] py-1 flex mb-[7px]">
                <div className="overflow-auto  lg:overflow-hidden">
                    <div className="whitespace-nowrap">
                        <ul className="inline-block">
                            <li className="cursor-pointer inline-block">
                                <a className="btneffect !flex items-center text-[#fff] text-[15px] font-bold cursor-pointer">
                                    <div className="inline-block mr-2">
                                        <img src="/assets/svg/dog-login.svg" className="horsehomeimg" />
                                    </div>
                                    <div className="mr-[20px]  text-center inline-block horsename-title">
                                        <div>Hatrick (NZL) 14th Feb</div>
                                        <div className="text-light-grey">27th Jan 22:01</div>
                                    </div>
                                </a>
                            </li>
                            <li className="cursor-pointer inline-block">
                                <a className="btneffect !flex items-center text-[#fff] text-[15px] font-bold cursor-pointer">
                                    <div className="inline-block mr-2">
                                        <img src="/assets/svg/dog-login.svg" className="horsehomeimg" />
                                    </div>
                                    <div className="mr-[20px]  text-center inline-block horsename-title">
                                        <div>Horsham (AUS) 14th Feb</div>
                                        <div className="text-light-grey">14th Feb 10:02</div>
                                    </div>
                                </a>
                            </li>
                            <li className="cursor-pointer inline-block">
                                <a className="btneffect !flex items-center text-[#fff] text-[15px] font-bold cursor-pointer">
                                    <div className="inline-block mr-2">
                                        <img src="/assets/svg/dog-login.svg" className="horsehomeimg" />
                                    </div>
                                    <div className="mr-[20px]  text-center inline-block horsename-title">
                                        <div>Ipswich (AUS) 14th Feb</div>
                                        <div className="text-light-grey">14th Feb 11:02</div>
                                    </div>
                                </a>
                            </li>
                            <li className="cursor-pointer inline-block">
                                <a className="btneffect !flex items-center text-[#fff] text-[15px] font-bold cursor-pointer">
                                    <div className="inline-block mr-2">
                                        <img src="/assets/svg/dog-login.svg" className="horsehomeimg" />
                                    </div>
                                    <div className="mr-[20px]  text-center inline-block horsename-title">
                                        <div>Ipswich (AUS) 14th Feb</div>
                                        <div className="text-light-grey">14th Feb 11:02</div>
                                    </div>
                                </a>
                            </li>
                            <li className="cursor-pointer inline-block">
                                <a className="btneffect !flex items-center text-[#fff] text-[15px] font-bold cursor-pointer">
                                    <div className="inline-block mr-2">
                                        <img src="/assets/svg/dog-login.svg" className="horsehomeimg" />
                                    </div>
                                    <div className="mr-[20px]  text-center inline-block horsename-title">
                                        <div>Ipswich (AUS) 14th Feb</div>
                                        <div className="text-light-grey">14th Feb 11:02</div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GreyhoundRacing;
